/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CommunityCliQ API
 *  ## Authentication
 *
 *   Every request must include an API access token generated in the CommunityCliQ \
 *   application:
 *
 *   ```
 *   Authorization: X-API-TOKEN
 *   ```
 *
 * OpenAPI spec version: V2.X
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CommandErrorResponse,
  ZendeskAuthorizationInformationResponse,
  ZendeskWidgetAuthorizationInformationResponse,
} from "../../model";

import { customInstance } from "../../../lib/SpringAxios";
import type { ErrorType } from "../../../lib/SpringAxios";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") {
      continue;
    }
    Object.defineProperty(result, key, {
      configurable: true,
      enumerable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Gets the Zendesk authorization information.
 * @summary Gets the Zendesk authorization information.
 */
export const getZendeskWidgetAuthorizationInformation = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ZendeskWidgetAuthorizationInformationResponse>(
    {
      method: "GET",
      signal,
      url: `/api/v2/integrations/zendesk/widget/authorization`,
    },
    options,
  );
};

export const getGetZendeskWidgetAuthorizationInformationQueryKey = () => {
  return [`/api/v2/integrations/zendesk/widget/authorization`] as const;
};

export const getGetZendeskWidgetAuthorizationInformationQueryOptions = <
  TData = Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetZendeskWidgetAuthorizationInformationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>
  > = ({ signal }) =>
    getZendeskWidgetAuthorizationInformation(requestOptions, signal);

  return { queryFn, queryKey, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetZendeskWidgetAuthorizationInformationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>
>;
export type GetZendeskWidgetAuthorizationInformationQueryError =
  ErrorType<CommandErrorResponse>;

export function useGetZendeskWidgetAuthorizationInformation<
  TData = Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
          TError,
          Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetZendeskWidgetAuthorizationInformation<
  TData = Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
          TError,
          Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetZendeskWidgetAuthorizationInformation<
  TData = Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the Zendesk authorization information.
 */

export function useGetZendeskWidgetAuthorizationInformation<
  TData = Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getZendeskWidgetAuthorizationInformation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetZendeskWidgetAuthorizationInformationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Gets the Zendesk authorization information.
 * @summary Gets the Zendesk authorization information.
 */
export const getZendeskAuthorizationInformation = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ZendeskAuthorizationInformationResponse>(
    {
      method: "GET",
      signal,
      url: `/api/v2/integrations/zendesk/authorization`,
    },
    options,
  );
};

export const getGetZendeskAuthorizationInformationQueryKey = () => {
  return [`/api/v2/integrations/zendesk/authorization`] as const;
};

export const getGetZendeskAuthorizationInformationQueryOptions = <
  TData = Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetZendeskAuthorizationInformationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>
  > = ({ signal }) =>
    getZendeskAuthorizationInformation(requestOptions, signal);

  return { queryFn, queryKey, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetZendeskAuthorizationInformationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>
>;
export type GetZendeskAuthorizationInformationQueryError =
  ErrorType<CommandErrorResponse>;

export function useGetZendeskAuthorizationInformation<
  TData = Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
          TError,
          Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetZendeskAuthorizationInformation<
  TData = Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
          TError,
          Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetZendeskAuthorizationInformation<
  TData = Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the Zendesk authorization information.
 */

export function useGetZendeskAuthorizationInformation<
  TData = Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getZendeskAuthorizationInformation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetZendeskAuthorizationInformationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
